import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
declare var jQuery: any;

@Component({
  selector: 'app-website-header',
  templateUrl: './website-header.component.html',
  styleUrls: ['./website-header.component.css']
})

export class WebsiteHeaderComponent implements OnInit {

  constructor(public toastr:ToastrService,
              public router:Router) { }

  ngOnInit(): void {

    (function ($) {
      "use strict";
  
      $(function () {
        var header = $(".start-style");
        $(window).scroll(function () {
          var scroll = $(window).scrollTop();
  
          if (scroll >= 10) {
            header.removeClass('start-style').addClass("scroll-on");
          } else {
            header.removeClass("scroll-on").addClass('start-style');
          }
        });
      });
  
      //Menu On Hover
  
      $('body').on('mouseenter mouseleave', '.nav-item', function (e) {
        if ($(window).width() > 750) {
          var _d = $(e.target).closest('.nav-item'); _d.addClass('show');
          setTimeout(function () {
            _d[_d.is(':hover') ? 'addClass' : 'removeClass']('show');
          }, 1);
        }
      });

  
    })(jQuery);

  }

  ramki()
  {
    this.toastr.warning("Please Login First");
    setTimeout(() => {
      this.router.navigate(['login']);
    }, 500);
  }

}
